import { gql } from '@apollo/client';
import { OPS_INCIDENT_DETAIL_FIELDS } from '../queries/opsIncidents';

/**
 * Raise a ticket by hand. `title`, `message` and `service` are required.
 * `classifyWithModel: true` has the classifier model read the ticket and fill
 * in its category, likely cause and suggested fix; it is always sent, false
 * unless asked for, since each classification is a model call.
 */
export const CREATE_OPS_INCIDENT = gql`
  mutation CreateOpsIncident(
    $title: String!
    $message: String!
    $service: String!
    $severity: String!
    $category: String!
    $loggerName: String
    $exceptionType: String
    $tracebackTail: String
    $likelyCause: String
    $suggestedFix: String
    $assignedTo: String
    $usersImpacted: [String!]
    $occurrences: Int!
    $classifyWithModel: Boolean!
  ) {
    createOpsIncident(
      title: $title
      message: $message
      service: $service
      severity: $severity
      category: $category
      loggerName: $loggerName
      exceptionType: $exceptionType
      tracebackTail: $tracebackTail
      likelyCause: $likelyCause
      suggestedFix: $suggestedFix
      assignedTo: $assignedTo
      usersImpacted: $usersImpacted
      occurrences: $occurrences
      classifyWithModel: $classifyWithModel
    ) {
      ${OPS_INCIDENT_DETAIL_FIELDS}
    }
  }
`;

/** Change a ticket. Only the fields passed change. */
export const UPDATE_OPS_INCIDENT = gql`
  mutation UpdateOpsIncident(
    $id: Int!
    $status: String
    $assignedTo: String
    $resolutionNotes: String
    $title: String
    $severity: String
    $category: String
    $service: String
    $likelyCause: String
    $suggestedFix: String
    $usersImpacted: [String!]
  ) {
    updateOpsIncident(
      id: $id
      status: $status
      assignedTo: $assignedTo
      resolutionNotes: $resolutionNotes
      title: $title
      severity: $severity
      category: $category
      service: $service
      likelyCause: $likelyCause
      suggestedFix: $suggestedFix
      usersImpacted: $usersImpacted
    ) {
      ${OPS_INCIDENT_DETAIL_FIELDS}
    }
  }
`;

/**
 * Run the log monitor agent over the last `minutes` of logs. `dryRun: true`
 * reports what it would raise and saves nothing; `source: "files"` reads local
 * log files instead of CloudWatch.
 */
export const RUN_LOG_MONITOR = gql`
  mutation RunLogMonitor($minutes: Int!, $dryRun: Boolean!, $source: String) {
    runLogMonitor(minutes: $minutes, dryRun: $dryRun, source: $source) {
      windowMinutes
      events
      errorRecords
      noiseRecords
      signatures
      new
      updated
      reopened
      escalated
      modelCalled
      hot
      seconds
      unreadableGroups
      truncatedGroups
      tickets {
        fingerprint
        severity
        priority
        title
        new
        count
        users
        reopened
        escalated
      }
    }
  }
`;
